import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import { triggerSavedSearchActivatedEvent } from 'Services/analytics/events';

import { ACTIONS, CATEGORIES } from './SavedFiltersGA.const';

const savedSearchHoverEvents = {
	active: {
		action: ACTIONS.hoverActiveSavedSearchButton,
		category: CATEGORIES.ADD,
	},
	disabled: {
		action: ACTIONS.hoverDisabledSavedSearchButton,
		category: CATEGORIES.PILL,
	},
};

// XXX: need to move each separate trigger to analytics/events folder and adjust naming
export const savedSearchesGaEvent = ({ action, category = CATEGORIES.DEFAULT, label }) => {
	const eventPayload = getSnowplowEventPayload({
		category,
		customData: { label },
		name: action,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerSavedFilterHoverGAEvent = ({ visible }) => {
	const actionText = 'search';

	if (visible) {
		savedSearchesGaEvent({
			action: `User hovered over saved ${actionText} pill`,
		});
	}
};

export const triggerSavedFilterSaveChipHoverGAEvent = (isUniqueFilter) => {
	const savedSearchHoverEvent = savedSearchHoverEvents[isUniqueFilter ? 'active' : 'disabled'];

	savedSearchesGaEvent(savedSearchHoverEvent);
};

export const triggerSavedFilterNameChangedGAEvent = (name, category = CATEGORIES.ADD) => {
	savedSearchesGaEvent({
		action: 'Saved search name changed',
		category,
		label: name,
	});
};

export const triggerSavedFilterDailyEmailAlertHoverGAEvent = () => {
	savedSearchesGaEvent({
		action: 'Daily stock alert tooltip hover',
		category: CATEGORIES.ADD,
	});
};

export const triggerSavedFilterFirstFocusScreenGAEvent = () => {
	savedSearchesGaEvent({
		action: 'First saved search focus screen view',
		category: CATEGORIES.ADD,
	});
};

export const triggerSavedFilterLimitReachedGAEvent = () => {
	savedSearchesGaEvent({
		action: 'Saved search limit reached',
		category: CATEGORIES.ADD,
	});
};

export const triggerSavedFilterCancelGAEvent = () => {
	savedSearchesGaEvent({
		action: 'Cancel button clicked',
		category: CATEGORIES.ADD,
	});
};

export const triggerSavedFilterCloseClickAddScreenGAEvent = () => {
	savedSearchesGaEvent({
		action: 'X button clicked',
		category: CATEGORIES.ADD,
	});
};

export const triggerSavedFilterSaveChangesGAEvent = () => {
	savedSearchesGaEvent({
		action: 'Save changes button clicked',
		category: CATEGORIES.MANAGE,
	});
};

export const triggerSavedFilterTabChangedGAEvent = (id) => {
	savedSearchesGaEvent({
		action: 'Saved search selected',
		category: CATEGORIES.MANAGE,
		label: String(id),
	});
};

export const triggerSavedFilterEmptyStateGAEvent = () => {
	savedSearchesGaEvent({
		action: 'Empty state',
		category: CATEGORIES.MANAGE,
	});
};

export const triggerSavedFilterEmptyStateBrowseVehiclesClickGAEvent = () => {
	savedSearchesGaEvent({
		action: 'Empty state - browse button clicked',
		category: CATEGORIES.MANAGE,
	});
};

export const onSetCurrentFilterGA = ({ currentFilter, prevFilter, savedFilters }) => {
	const isPageLoadedWithFilter = currentFilter !== undefined && prevFilter === undefined && savedFilters.length > 0;

	if (isPageLoadedWithFilter) {
		triggerSavedSearchActivatedEvent(true);
	}
};
